import INVENTORY_API_BASE_URL from "../../config/api";
import "./mis.css";
import { useState, useEffect } from "react";
import Axios from "axios";
import Table from "react-bootstrap/Table";
import ReactDOM from "react-dom";
import image2 from "../../uploads/pinnacle_logo.png";
import Button from "react-bootstrap/Button";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFViewer,
  Image,
} from "@react-pdf/renderer";

function Mis() {
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [selectedOrderID, setSelectedOrderID] = useState("");
  const [grnData, setGrnData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [ordersResponse, suppliersResponse, grnResponse] =
          await Promise.all([
            Axios.get(`${INVENTORY_API_BASE_URL}/getOrder`),
            Axios.get(`${INVENTORY_API_BASE_URL}/getbooksupplier`),
            Axios.get(`${INVENTORY_API_BASE_URL}/getCreateGrn`), 
          ]);

        setData(ordersResponse.data);
        setData1(suppliersResponse.data);
        setGrnData(grnResponse.data); 
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };
  

  const filteredData = data.filter((row) => row.ApprovalDate !== null);

  useEffect(() => {
    const filteredData2 = data.filter((row) => row.orderid === selectedOrderID);
    if (selectedOrderID !== "") {
      renderPDFContent(filteredData2);
    }
  }, [selectedOrderID]);

  const handleButtonClick = (orderID) => {
    setSelectedOrderID(orderID);
  };

  const renderPDFContent = (filteredData2) => {
    let subtotal = 0;
    let totalApprovedQuantity = 0;
    const itemsPerPage = 8;
    let totalCount = 0;

    filteredData2.forEach((item) => {
      if (item.updatedQuantity) {
        item.updatedQuantity.forEach((updatedItem) => {
          subtotal += updatedItem.purchasePrice * updatedItem.approvedquantity;
          totalApprovedQuantity += updatedItem.approvedquantity;
        });
      }
    });


    const styles = StyleSheet.create({
      page: {
        flexDirection: "column",
      },
      section: {
        flexDirection: "row",
        margin: 15,
      },
      title: {
        fontSize: 12,
      },
      listItem: {
        marginBottom: 0.5,
      },
      box: {
        border: "1px solid black",
      },
      stationView: {
        border: "1px solid black",
        padding: 5,
      },
      pdfhead: {
        textAlign: "center",
        marginTop: 16,
        marginBottom: 25,
      },
      pdfhead2: {
        textAlign: "left",
        marginLeft: 12,
        fontSize: 12,
      },
      pdfdetails: {
        fontSize: 12,
        marginLeft: 5,
      },
      pdfaddress: {
        fontSize: 12,
      },
      column: {
        flex: 1,
        border: "1px solid black",
        margin: 5,
      },
      details: {
        textAlign: "center",
        fontSize: 14,
        fontWeight: "bold",
      },
      shipto: {
        textAlign: "center",
        fontSize: 14,
        fontWeight: "bold",
      },
      address: {
        fontSize: 10,
        marginBottom: 9,
      },
      secondrow: {
        border: "1px solid black",
        margin: 10,
      },
      table: {
        marginTop: 10,
        marginBottom: 10,
        fontSize: 12,
      },
      tableRow: {
        flexDirection: "row",
        borderBottomWidth: 1,
        borderBottomColor: "black",
        paddingBottom: 5,
        marginBottom: 5,
        fontSize: 7,
      },
      tableCell: {
        flex: 1,
        padding: 5,
        fontSize: 10,
      },
      tableHeaderCell: {
        fontWeight: "bold",
      },
      underline: {
        marginLeft: 106,
        textAlign: "center",
        fontSize: 12,
      },
      underline2: {
        marginTop: -40,
        marginLeft: 470,
        marginRight: 50,
        textAlign: "center",
        fontSize: 12,
      },
      col1: {
        display: "flex",
        flexDirection: "row",
        marginLeft: 222,
        marginTop: 14,
      },
      signature: {
        fontSize: 12,
        marginLeft: 400,
        marginBottom: 10,
      },
      filtered2: {
        position: "absolute",
        marginLeft: 450,
        marginTop: 56,
      },

      filtered3: {
        position: "absolute",
        marginLeft: 400,
        marginTop: 76,
        fontSize: 15,
      },

      filtered4: {
        position: "absolute",
        marginLeft: 400,
        marginTop: 92,
        fontSize: 15,
      },

      filtered5: {
        position: "absolute",
        marginLeft: 30,
        marginTop: 42,
        fontSize: 15,
      },

      suppliername1: {
        fontSize: 14,
        marginBottom: 12,
        marginTop: 5,
        textAlign: "center",
      },
      suppliername: {
        fontSize: 14,
        marginBottom: 12,
        marginTop: 5,
        textAlign: "center",
      },
      logo: {
        position: "absolute",
        marginRight: 442,
        marginTop: 5,
      },
      mainview: {
        marginLeft: 15,
        marginRight: 15,
      },
      PP: {
        fontSize: 12,
        marginLeft: 400,
        marginBottom: 10,
        marginTop: 5,
      },
      forthrow: {
        border: "1px solid black",
        marginLeft: 4,
        marginRight: 4,
        marginTop: 8,
      },
    });

    const pdfContent = (
      <Document>
        {filteredData2.map((item, index) => {
          if (item.updatedQuantity) {
            const numPages = Math.ceil(
              item.updatedQuantity.length / itemsPerPage
            );

            return Array.from({ length: numPages }).map((_, pageIndex) => {
              const startIndex = pageIndex * itemsPerPage;
              const endIndex = startIndex + itemsPerPage;
              const itemsToRender = item.updatedQuantity.slice(
                startIndex,
                endIndex
              );

              return (
                <Page key={index} style={styles.page}>
                  <View style={styles.mainview}>
                    <View>
                      <View style={styles.logo}>
                        <Image
                          src={image2}
                          style={{
                            width: 150,
                            height: 60,
                            marginLeft: 12,
                            marginBottom: 5,
                          }}
                        />
                      </View>
                      <Text style={styles.pdfhead}>MIS Report</Text>
                      <Text style={styles.pdfhead2}>
                        PINNACLE CIVIL SERVICES
                      </Text>
                      <Text style={styles.pdfhead2}>
                        1st Floor, 1032A, MM Tower, New Railway Road,
                      </Text>
                      <Text style={styles.pdfhead2}>
                        Dayanand Colony, Gurugram, Haryana 122006 Code: 06
                      </Text>
                      <View style={styles.filtered2}>
                        <Text>Order No: {item.orderid}</Text>
                      </View>
                      <View style={styles.filtered3}>
                      <Text>Order Date: {formatDate(item.ApprovalDate)}</Text>

                      </View>
                    </View>
                    <View style={styles.section}>
                      <View style={styles.column}>
                        <View>
                          <Text style={styles.details}>Vendor:-</Text>
                          {data1.map((ite) => (
                            <View key={ite.id}>
                              <Text style={styles.suppliername}>
                                {ite.Booksupplier}
                              </Text>
                              <Text style={styles.address}>{ite.Address}</Text>
                            </View>
                          ))}
                        </View>
                      </View>
                      <View style={styles.column}>
                        <View>
                          <Text style={styles.shipto}>Ship To:-</Text>
                          <Text style={styles.suppliername1}>
                            Pinnacle Civil Services
                          </Text>
                          <Text style={styles.address}>
                            Hare Ram Plaza Basement, old Railway road, sector-4
                            nearby chintapurni mandir Below redtap showroom,
                            gurugram, Haryana, 122001
                          </Text>
                        </View>
                      </View>
                    </View>

                    <View style={styles.secondrow}>
                      <View style={styles.table}>
                        <View style={[styles.tableRow, styles.tableHeaderCell]}>
                          <View style={styles.tableCell}>
                            <Text>SN</Text>
                          </View>
                          <View style={styles.tableCell}>
                            <Text>Title</Text>
                          </View>
                          <View style={styles.tableCell}>
                            <Text>Order Quantity</Text>
                          </View>
                          <View style={styles.tableCell}>
                            <Text>Received Quantity</Text>
                          </View>

                          <View style={styles.tableCell}>
                            <Text>Balance Quantity</Text>
                          </View>
                        </View>
                        {itemsToRender.map((updatedItem, updatedIndex) => {
                          totalCount++;
                          return (
                            <View key={updatedIndex} style={styles.tableRow}>
                              <View style={[styles.tableCell, { flex: 0.5 }]}>
                                <Text>{totalCount}</Text>
                              </View>
                              <View style={[styles.tableCell, { flex: 2 }]}>
                                <Text>{updatedItem.title}</Text>
                                <Text>Medium: {updatedItem.Medium}</Text>
                                <Text>Edition: {updatedItem.edition}</Text>
                              </View>

                              <View style={[styles.tableCell, { flex: 1 }]}>
                                <Text>{updatedItem.approvedquantity}</Text>
                              </View>
                              <View style={[styles.tableCell, { flex: 1 }]}>
                                <Text>
                                  {grnData.length > 0
                                    ? grnData
                                        .filter(
                                          (grnItem) =>
                                            String(grnItem.orderno) ===
                                              String(item.orderid) &&
                                            grnItem.title === updatedItem.title
                                        )
                                        .map(
                                          (matchedItem) =>
                                            matchedItem.challanquantity
                                        )
                                        .join(", ") || "N/A" 
                                    : "Loading..."}
                                </Text>
                              </View>

                              <View style={[styles.tableCell, { flex: 1 }]}>
                                <Text>
                                  {(() => {
                                    const receivedQuantities =
                                      grnData.length > 0
                                        ? grnData
                                            .filter(
                                              (grnItem) =>
                                                String(grnItem.orderno) ===
                                                  String(item.orderid) &&
                                                grnItem.title ===
                                                  updatedItem.title
                                            )
                                            .map(
                                              (matchedItem) =>
                                                matchedItem.challanquantity
                                            ) 
                                        : [];

                                    const totalReceivedQuantity =
                                      receivedQuantities.length
                                        ? receivedQuantities.reduce(
                                            (sum, qty) => sum + qty,
                                            0
                                          ) 
                                        : 0;

                                    const balanceQuantity =
                                      updatedItem.approvedquantity -
                                      totalReceivedQuantity;

                                    return balanceQuantity < 0
                                      ? `(extra) ${Math.abs(balanceQuantity)}`
                                      : balanceQuantity;
                                  })()}
                                </Text>
                              </View>
                            </View>
                          );
                        })}
                      </View>
                    </View>
                  </View>
                </Page>
              );
            });
          }
        })}
      </Document>
    );

    const newWindow = window.open();
    ReactDOM.render(
      <PDFViewer width="100%" height="100%">
        {pdfContent}
      </PDFViewer>,
      newWindow.document.body
    );
  };

  return (
    <div>
      <div className="pogiven">
        <h4>MIS Report</h4>
      </div>
      <br />
      <Table stripeh className="mistable">
        <thead>
          <tr>
            <th>OrderNo</th>

            <th>Order Date</th>
            <th>sku</th>
            <th>Total Quantity</th>

            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.map((row) => (
            <tr key={row.orderid}>
              <td style={{ padding: "1.5rem" }}>{row.orderid}</td>

              <td style={{ padding: "1.5rem" }} data-label="Approval-Date">
                {formatDate(row.ApprovalDate)}
              </td>
              <td style={{ padding: "1.5rem" }}>{row.list.length}</td>
              <td style={{ padding: "1.5rem" }}>
                {row.updatedQuantity.length > 0
                  ? row.updatedQuantity
                      .map((item) => item.approvedquantity)
                      .reduce((acc, value) => acc + value, 0)
                  : 0}
              </td>

              <td>
                <Button
                  className="pogivenhandle"
                  onClick={() => handleButtonClick(row.orderid)}
                >
                  Show PDF
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}

export default Mis;
